export default __webpack_public_path__ + "static/media/newmembers.ddc20058.png";